import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var ParticipantType = /*#__PURE__*/function (ParticipantType) {
  ParticipantType[ParticipantType["PARTICIPANT_TYPE_UNKNOWN"] = 0] = "PARTICIPANT_TYPE_UNKNOWN";
  ParticipantType[ParticipantType["PARTICIPANT_TYPE_ACCOUNT_GROUP"] = 1] = "PARTICIPANT_TYPE_ACCOUNT_GROUP";
  ParticipantType[ParticipantType["PARTICIPANT_TYPE_CUSTOMER"] = 2] = "PARTICIPANT_TYPE_CUSTOMER";
  return ParticipantType;
}(ParticipantType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var OwnerType = /*#__PURE__*/function (OwnerType) {
  OwnerType[OwnerType["OWNER_TYPE_UNSPECIFIED"] = 0] = "OWNER_TYPE_UNSPECIFIED";
  OwnerType[OwnerType["OWNER_TYPE_PARTNER"] = 1] = "OWNER_TYPE_PARTNER";
  OwnerType[OwnerType["OWNER_TYPE_ACCOUNT_GROUP"] = 2] = "OWNER_TYPE_ACCOUNT_GROUP";
  return OwnerType;
}(OwnerType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var DataField = /*#__PURE__*/function (DataField) {
  DataField[DataField["DATA_FIELD_UNSPECIFIED"] = 0] = "DATA_FIELD_UNSPECIFIED";
  DataField[DataField["DATA_FIELD_LEGAL_BUSINESS_NAME"] = 1] = "DATA_FIELD_LEGAL_BUSINESS_NAME";
  DataField[DataField["DATA_FIELD_BUSINESS_CATEGORY"] = 2] = "DATA_FIELD_BUSINESS_CATEGORY";
  DataField[DataField["DATA_FIELD_BUSINESS_TYPE"] = 3] = "DATA_FIELD_BUSINESS_TYPE";
  DataField[DataField["DATA_FIELD_REGION_OF_OPERATION"] = 4] = "DATA_FIELD_REGION_OF_OPERATION";
  DataField[DataField["DATA_FIELD_REGISTRATION_IDENTIFIER"] = 5] = "DATA_FIELD_REGISTRATION_IDENTIFIER";
  DataField[DataField["DATA_FIELD_STREET_ADDRESS"] = 6] = "DATA_FIELD_STREET_ADDRESS";
  DataField[DataField["DATA_FIELD_STREET_ADDRESS_SECONDARY"] = 7] = "DATA_FIELD_STREET_ADDRESS_SECONDARY";
  DataField[DataField["DATA_FIELD_CITY"] = 8] = "DATA_FIELD_CITY";
  DataField[DataField["DATA_FIELD_STATE"] = 9] = "DATA_FIELD_STATE";
  DataField[DataField["DATA_FIELD_POSTAL_CODE"] = 10] = "DATA_FIELD_POSTAL_CODE";
  DataField[DataField["DATA_FIELD_WEBSITE_URL"] = 11] = "DATA_FIELD_WEBSITE_URL";
  DataField[DataField["DATA_FIELD_COUNTRY"] = 12] = "DATA_FIELD_COUNTRY";
  DataField[DataField["DATA_FIELD_FIRST_NAME"] = 13] = "DATA_FIELD_FIRST_NAME";
  DataField[DataField["DATA_FIELD_LAST_NAME"] = 14] = "DATA_FIELD_LAST_NAME";
  DataField[DataField["DATA_FIELD_JOB_POSITION"] = 15] = "DATA_FIELD_JOB_POSITION";
  DataField[DataField["DATA_FIELD_BUSINESS_TITLE"] = 16] = "DATA_FIELD_BUSINESS_TITLE";
  DataField[DataField["DATA_FIELD_EMAIL"] = 17] = "DATA_FIELD_EMAIL";
  DataField[DataField["DATA_FIELD_PHONE_NUMBER"] = 18] = "DATA_FIELD_PHONE_NUMBER";
  DataField[DataField["DATA_FIELD_BUSINESS_REGISTRATION_NUMBER"] = 19] = "DATA_FIELD_BUSINESS_REGISTRATION_NUMBER";
  return DataField;
}(DataField || {});
var BrandStatus = /*#__PURE__*/function (BrandStatus) {
  BrandStatus[BrandStatus["BRAND_STATUS_UNSPECIFIED"] = 0] = "BRAND_STATUS_UNSPECIFIED";
  BrandStatus[BrandStatus["BRAND_STATUS_PENDING"] = 1] = "BRAND_STATUS_PENDING";
  BrandStatus[BrandStatus["BRAND_STATUS_IN_REVIEW"] = 2] = "BRAND_STATUS_IN_REVIEW";
  BrandStatus[BrandStatus["BRAND_STATUS_FAILED"] = 3] = "BRAND_STATUS_FAILED";
  BrandStatus[BrandStatus["BRAND_STATUS_APPROVED"] = 4] = "BRAND_STATUS_APPROVED";
  return BrandStatus;
}(BrandStatus || {});
var MessagingCampaignStatus = /*#__PURE__*/function (MessagingCampaignStatus) {
  MessagingCampaignStatus[MessagingCampaignStatus["MESSAGING_CAMPAIGN_STATUS_UNSPECIFIED"] = 0] = "MESSAGING_CAMPAIGN_STATUS_UNSPECIFIED";
  MessagingCampaignStatus[MessagingCampaignStatus["MESSAGING_CAMPAIGN_STATUS_PENDING"] = 1] = "MESSAGING_CAMPAIGN_STATUS_PENDING";
  MessagingCampaignStatus[MessagingCampaignStatus["MESSAGING_CAMPAIGN_STATUS_FAILED"] = 2] = "MESSAGING_CAMPAIGN_STATUS_FAILED";
  MessagingCampaignStatus[MessagingCampaignStatus["MESSAGING_CAMPAIGN_STATUS_VERIFIED"] = 3] = "MESSAGING_CAMPAIGN_STATUS_VERIFIED";
  return MessagingCampaignStatus;
}(MessagingCampaignStatus || {});
var ValidationStatus = /*#__PURE__*/function (ValidationStatus) {
  ValidationStatus[ValidationStatus["VALIDATION_STATUS_UNSPECIFIED"] = 0] = "VALIDATION_STATUS_UNSPECIFIED";
  ValidationStatus[ValidationStatus["VALIDATION_STATUS_COMPLIANT"] = 1] = "VALIDATION_STATUS_COMPLIANT";
  ValidationStatus[ValidationStatus["VALIDATION_STATUS_NON_COMPLIANT"] = 2] = "VALIDATION_STATUS_NON_COMPLIANT";
  return ValidationStatus;
}(ValidationStatus || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var StatusType = /*#__PURE__*/function (StatusType) {
  StatusType[StatusType["STATUS_TYPE_UNSPECIFIED"] = 0] = "STATUS_TYPE_UNSPECIFIED";
  StatusType[StatusType["STATUS_TYPE_QUEUED"] = 1] = "STATUS_TYPE_QUEUED";
  StatusType[StatusType["STATUS_TYPE_SENDING"] = 2] = "STATUS_TYPE_SENDING";
  StatusType[StatusType["STATUS_TYPE_SENT"] = 3] = "STATUS_TYPE_SENT";
  StatusType[StatusType["STATUS_TYPE_FAILED"] = 4] = "STATUS_TYPE_FAILED";
  StatusType[StatusType["STATUS_TYPE_DELIVERED"] = 5] = "STATUS_TYPE_DELIVERED";
  StatusType[StatusType["STATUS_TYPE_UNDELIVERED"] = 6] = "STATUS_TYPE_UNDELIVERED";
  StatusType[StatusType["STATUS_TYPE_RECEIVING"] = 7] = "STATUS_TYPE_RECEIVING";
  StatusType[StatusType["STATUS_TYPE_RECEIVED"] = 8] = "STATUS_TYPE_RECEIVED";
  StatusType[StatusType["STATUS_TYPE_ACCEPTED"] = 9] = "STATUS_TYPE_ACCEPTED";
  StatusType[StatusType["STATUS_TYPE_SCHEDULED"] = 10] = "STATUS_TYPE_SCHEDULED";
  StatusType[StatusType["STATUS_TYPE_CANCELED"] = 11] = "STATUS_TYPE_CANCELED";
  return StatusType;
}(StatusType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var LimitType = /*#__PURE__*/function (LimitType) {
  LimitType[LimitType["LIMIT_TYPE_UNSPECIFIED"] = 0] = "LIMIT_TYPE_UNSPECIFIED";
  LimitType[LimitType["LIMIT_TYPE_DAILY"] = 1] = "LIMIT_TYPE_DAILY";
  return LimitType;
}(LimitType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums Index.
// *********************************

function enumStringToValue$5(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Participant {
  static fromProto(proto) {
    let m = new Participant();
    m = Object.assign(m, proto);
    if (proto.type) {
      m.type = enumStringToValue$5(ParticipantType, proto.type);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.internalId !== 'undefined') {
      toReturn['internalId'] = this.internalId;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    return toReturn;
  }
}
function enumStringToValue$4(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class A2PRegistrationInfo {
  static fromProto(proto) {
    let m = new A2PRegistrationInfo();
    m = Object.assign(m, proto);
    if (proto.ownerType) {
      m.ownerType = enumStringToValue$4(OwnerType, proto.ownerType);
    }
    if (proto.business) {
      m.business = Business.fromProto(proto.business);
    }
    if (proto.authorizedRepresentative) {
      m.authorizedRepresentative = AuthorizedRepresentative.fromProto(proto.authorizedRepresentative);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.submitted) {
      m.submitted = new Date(proto.submitted);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.ownerId !== 'undefined') {
      toReturn['ownerId'] = this.ownerId;
    }
    if (typeof this.ownerType !== 'undefined') {
      toReturn['ownerType'] = this.ownerType;
    }
    if (typeof this.friendlyName !== 'undefined') {
      toReturn['friendlyName'] = this.friendlyName;
    }
    if (typeof this.business !== 'undefined' && this.business !== null) {
      toReturn['business'] = 'toApiJson' in this.business ? this.business.toApiJson() : this.business;
    }
    if (typeof this.authorizedRepresentative !== 'undefined' && this.authorizedRepresentative !== null) {
      toReturn['authorizedRepresentative'] = 'toApiJson' in this.authorizedRepresentative ? this.authorizedRepresentative.toApiJson() : this.authorizedRepresentative;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.submitted !== 'undefined' && this.submitted !== null) {
      toReturn['submitted'] = 'toApiJson' in this.submitted ? this.submitted.toApiJson() : this.submitted;
    }
    return toReturn;
  }
}
class A2PRegistrationStatus {
  static fromProto(proto) {
    let m = new A2PRegistrationStatus();
    m = Object.assign(m, proto);
    if (proto.ownerType) {
      m.ownerType = enumStringToValue$4(OwnerType, proto.ownerType);
    }
    if (proto.secondaryBusinessProfile) {
      m.secondaryBusinessProfile = SecondaryBusinessProfile.fromProto(proto.secondaryBusinessProfile);
    }
    if (proto.trustBundle) {
      m.trustBundle = TrustBundle.fromProto(proto.trustBundle);
    }
    if (proto.brand) {
      m.brand = Brand.fromProto(proto.brand);
    }
    if (proto.messagingCampaign) {
      m.messagingCampaign = MessagingCampaign.fromProto(proto.messagingCampaign);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.ownerId !== 'undefined') {
      toReturn['ownerId'] = this.ownerId;
    }
    if (typeof this.ownerType !== 'undefined') {
      toReturn['ownerType'] = this.ownerType;
    }
    if (typeof this.subaccountId !== 'undefined') {
      toReturn['subaccountId'] = this.subaccountId;
    }
    if (typeof this.messagingServiceId !== 'undefined') {
      toReturn['messagingServiceId'] = this.messagingServiceId;
    }
    if (typeof this.secondaryBusinessProfile !== 'undefined' && this.secondaryBusinessProfile !== null) {
      toReturn['secondaryBusinessProfile'] = 'toApiJson' in this.secondaryBusinessProfile ? this.secondaryBusinessProfile.toApiJson() : this.secondaryBusinessProfile;
    }
    if (typeof this.trustBundle !== 'undefined' && this.trustBundle !== null) {
      toReturn['trustBundle'] = 'toApiJson' in this.trustBundle ? this.trustBundle.toApiJson() : this.trustBundle;
    }
    if (typeof this.brand !== 'undefined' && this.brand !== null) {
      toReturn['brand'] = 'toApiJson' in this.brand ? this.brand.toApiJson() : this.brand;
    }
    if (typeof this.messagingCampaign !== 'undefined' && this.messagingCampaign !== null) {
      toReturn['messagingCampaign'] = 'toApiJson' in this.messagingCampaign ? this.messagingCampaign.toApiJson() : this.messagingCampaign;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    return toReturn;
  }
}
class AuthorizedRepresentative {
  static fromProto(proto) {
    let m = new AuthorizedRepresentative();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.firstName !== 'undefined') {
      toReturn['firstName'] = this.firstName;
    }
    if (typeof this.lastName !== 'undefined') {
      toReturn['lastName'] = this.lastName;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.phoneNumber !== 'undefined') {
      toReturn['phoneNumber'] = this.phoneNumber;
    }
    if (typeof this.businessTitle !== 'undefined') {
      toReturn['businessTitle'] = this.businessTitle;
    }
    if (typeof this.jobPosition !== 'undefined') {
      toReturn['jobPosition'] = this.jobPosition;
    }
    return toReturn;
  }
}
class Brand {
  static fromProto(proto) {
    let m = new Brand();
    m = Object.assign(m, proto);
    if (proto.status) {
      m.status = enumStringToValue$4(BrandStatus, proto.status);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    return toReturn;
  }
}
class Business {
  static fromProto(proto) {
    let m = new Business();
    m = Object.assign(m, proto);
    if (proto.registrationIdentifier) {
      m.registrationIdentifier = RegistrationIdentifier.fromProto(proto.registrationIdentifier);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.legalName !== 'undefined') {
      toReturn['legalName'] = this.legalName;
    }
    if (typeof this.businessType !== 'undefined') {
      toReturn['businessType'] = this.businessType;
    }
    if (typeof this.industry !== 'undefined') {
      toReturn['industry'] = this.industry;
    }
    if (typeof this.registrationIdentifier !== 'undefined' && this.registrationIdentifier !== null) {
      toReturn['registrationIdentifier'] = 'toApiJson' in this.registrationIdentifier ? this.registrationIdentifier.toApiJson() : this.registrationIdentifier;
    }
    if (typeof this.regionOfOperation !== 'undefined') {
      toReturn['regionOfOperation'] = this.regionOfOperation;
    }
    if (typeof this.websiteUrl !== 'undefined') {
      toReturn['websiteUrl'] = this.websiteUrl;
    }
    if (typeof this.socialMediaProfileUrls !== 'undefined') {
      toReturn['socialMediaProfileUrls'] = this.socialMediaProfileUrls;
    }
    if (typeof this.streetAddress !== 'undefined') {
      toReturn['streetAddress'] = this.streetAddress;
    }
    if (typeof this.streetAddressSecondary !== 'undefined') {
      toReturn['streetAddressSecondary'] = this.streetAddressSecondary;
    }
    if (typeof this.city !== 'undefined') {
      toReturn['city'] = this.city;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.postalCode !== 'undefined') {
      toReturn['postalCode'] = this.postalCode;
    }
    if (typeof this.country !== 'undefined') {
      toReturn['country'] = this.country;
    }
    return toReturn;
  }
}
class MessagingCampaign {
  static fromProto(proto) {
    let m = new MessagingCampaign();
    m = Object.assign(m, proto);
    if (proto.status) {
      m.status = enumStringToValue$4(MessagingCampaignStatus, proto.status);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    return toReturn;
  }
}
class RegistrationIdentifier {
  static fromProto(proto) {
    let m = new RegistrationIdentifier();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.identifierType !== 'undefined') {
      toReturn['identifierType'] = this.identifierType;
    }
    if (typeof this.identifier !== 'undefined') {
      toReturn['identifier'] = this.identifier;
    }
    return toReturn;
  }
}
class SecondaryBusinessProfile {
  static fromProto(proto) {
    let m = new SecondaryBusinessProfile();
    m = Object.assign(m, proto);
    if (proto.status) {
      m.status = enumStringToValue$4(ValidationStatus, proto.status);
    }
    if (proto.fieldsWithIssues) {
      m.fieldsWithIssues = proto.fieldsWithIssues.map(v => enumStringToValue$4(DataField, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.authorizedRepresentativeId !== 'undefined') {
      toReturn['authorizedRepresentativeId'] = this.authorizedRepresentativeId;
    }
    if (typeof this.addressResourceId !== 'undefined') {
      toReturn['addressResourceId'] = this.addressResourceId;
    }
    if (typeof this.addressSupportingDocumentId !== 'undefined') {
      toReturn['addressSupportingDocumentId'] = this.addressSupportingDocumentId;
    }
    if (typeof this.secondaryBusinessInformationId !== 'undefined') {
      toReturn['secondaryBusinessInformationId'] = this.secondaryBusinessInformationId;
    }
    if (typeof this.fieldsWithIssues !== 'undefined') {
      toReturn['fieldsWithIssues'] = this.fieldsWithIssues;
    }
    return toReturn;
  }
}
class TrustBundle {
  static fromProto(proto) {
    let m = new TrustBundle();
    m = Object.assign(m, proto);
    if (proto.status) {
      m.status = enumStringToValue$4(ValidationStatus, proto.status);
    }
    if (proto.fieldsWithIssues) {
      m.fieldsWithIssues = proto.fieldsWithIssues.map(v => enumStringToValue$4(DataField, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.companyId !== 'undefined') {
      toReturn['companyId'] = this.companyId;
    }
    if (typeof this.fieldsWithIssues !== 'undefined') {
      toReturn['fieldsWithIssues'] = this.fieldsWithIssues;
    }
    return toReturn;
  }
}
function enumStringToValue$3(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Attribute {
  static fromProto(proto) {
    let m = new Attribute();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
function enumStringToValue$2(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class SupportingDocumentInfo {
  static fromProto(proto) {
    let m = new SupportingDocumentInfo();
    m = Object.assign(m, proto);
    if (proto.attributes) {
      m.attributes = proto.attributes.map(Attribute.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.documentType !== 'undefined') {
      toReturn['documentType'] = this.documentType;
    }
    if (typeof this.attributes !== 'undefined' && this.attributes !== null) {
      toReturn['attributes'] = 'toApiJson' in this.attributes ? this.attributes.toApiJson() : this.attributes;
    }
    if (typeof this.fileUrl !== 'undefined') {
      toReturn['fileUrl'] = this.fileUrl;
    }
    if (typeof this.processAddress !== 'undefined') {
      toReturn['processAddress'] = this.processAddress;
    }
    return toReturn;
  }
}
function enumStringToValue$1(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Access {
  static fromProto(proto) {
    let m = new Access();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.scope !== 'undefined') {
      toReturn['scope'] = this.scope;
    }
    if (typeof this.public !== 'undefined') {
      toReturn['public'] = this.public;
    }
    return toReturn;
  }
}
function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class ClaimPhoneNumberRequest {
  static fromProto(proto) {
    let m = new ClaimPhoneNumberRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.ownerId !== 'undefined') {
      toReturn['ownerId'] = this.ownerId;
    }
    return toReturn;
  }
}
class CreateA2PRegistrationInfoRequest {
  static fromProto(proto) {
    let m = new CreateA2PRegistrationInfoRequest();
    m = Object.assign(m, proto);
    if (proto.ownerType) {
      m.ownerType = enumStringToValue(OwnerType, proto.ownerType);
    }
    if (proto.business) {
      m.business = Business.fromProto(proto.business);
    }
    if (proto.authorizedRepresentative) {
      m.authorizedRepresentative = AuthorizedRepresentative.fromProto(proto.authorizedRepresentative);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.ownerId !== 'undefined') {
      toReturn['ownerId'] = this.ownerId;
    }
    if (typeof this.ownerType !== 'undefined') {
      toReturn['ownerType'] = this.ownerType;
    }
    if (typeof this.business !== 'undefined' && this.business !== null) {
      toReturn['business'] = 'toApiJson' in this.business ? this.business.toApiJson() : this.business;
    }
    if (typeof this.authorizedRepresentative !== 'undefined' && this.authorizedRepresentative !== null) {
      toReturn['authorizedRepresentative'] = 'toApiJson' in this.authorizedRepresentative ? this.authorizedRepresentative.toApiJson() : this.authorizedRepresentative;
    }
    if (typeof this.submitted !== 'undefined') {
      toReturn['submitted'] = this.submitted;
    }
    return toReturn;
  }
}
class CreateRegulationInfoRequest {
  static fromProto(proto) {
    let m = new CreateRegulationInfoRequest();
    m = Object.assign(m, proto);
    if (proto.ownerType) {
      m.ownerType = enumStringToValue(OwnerType, proto.ownerType);
    }
    if (proto.businessAttributes) {
      m.businessAttributes = proto.businessAttributes.map(Attribute.fromProto);
    }
    if (proto.supportingDocuments) {
      m.supportingDocuments = proto.supportingDocuments.map(SupportingDocumentInfo.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.ownerId !== 'undefined') {
      toReturn['ownerId'] = this.ownerId;
    }
    if (typeof this.ownerType !== 'undefined') {
      toReturn['ownerType'] = this.ownerType;
    }
    if (typeof this.countryCode !== 'undefined') {
      toReturn['countryCode'] = this.countryCode;
    }
    if (typeof this.businessAttributes !== 'undefined' && this.businessAttributes !== null) {
      toReturn['businessAttributes'] = 'toApiJson' in this.businessAttributes ? this.businessAttributes.toApiJson() : this.businessAttributes;
    }
    if (typeof this.supportingDocuments !== 'undefined' && this.supportingDocuments !== null) {
      toReturn['supportingDocuments'] = 'toApiJson' in this.supportingDocuments ? this.supportingDocuments.toApiJson() : this.supportingDocuments;
    }
    return toReturn;
  }
}
class CreateRegulationInfoResponse {
  static fromProto(proto) {
    let m = new CreateRegulationInfoResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.regulationInfoId !== 'undefined') {
      toReturn['regulationInfoId'] = this.regulationInfoId;
    }
    return toReturn;
  }
}
class CreateSmsClickedEventRequest {
  static fromProto(proto) {
    let m = new CreateSmsClickedEventRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.messageUuid !== 'undefined') {
      toReturn['messageUuid'] = this.messageUuid;
    }
    return toReturn;
  }
}
class DeleteA2PRegistrationInfoRequest {
  static fromProto(proto) {
    let m = new DeleteA2PRegistrationInfoRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.ownerId !== 'undefined') {
      toReturn['ownerId'] = this.ownerId;
    }
    return toReturn;
  }
}
class GetA2PRegistrationInfoRequest {
  static fromProto(proto) {
    let m = new GetA2PRegistrationInfoRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.ownerId !== 'undefined') {
      toReturn['ownerId'] = this.ownerId;
    }
    return toReturn;
  }
}
class GetA2PRegistrationInfoResponse {
  static fromProto(proto) {
    let m = new GetA2PRegistrationInfoResponse();
    m = Object.assign(m, proto);
    if (proto.a2pRegistrationInfo) {
      m.a2pRegistrationInfo = A2PRegistrationInfo.fromProto(proto.a2pRegistrationInfo);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.a2pRegistrationInfo !== 'undefined' && this.a2pRegistrationInfo !== null) {
      toReturn['a2pRegistrationInfo'] = 'toApiJson' in this.a2pRegistrationInfo ? this.a2pRegistrationInfo.toApiJson() : this.a2pRegistrationInfo;
    }
    return toReturn;
  }
}
class GetAccountInfoRequest {
  static fromProto(proto) {
    let m = new GetAccountInfoRequest();
    m = Object.assign(m, proto);
    if (proto.sender) {
      m.sender = Participant.fromProto(proto.sender);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sender !== 'undefined' && this.sender !== null) {
      toReturn['sender'] = 'toApiJson' in this.sender ? this.sender.toApiJson() : this.sender;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    return toReturn;
  }
}
class GetAccountInfoResponse {
  static fromProto(proto) {
    let m = new GetAccountInfoResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.phoneNumber !== 'undefined') {
      toReturn['phoneNumber'] = this.phoneNumber;
    }
    if (typeof this.subaccountId !== 'undefined') {
      toReturn['subaccountId'] = this.subaccountId;
    }
    return toReturn;
  }
}
class GetAttributeEventStatsRequest {
  static fromProto(proto) {
    let m = new GetAttributeEventStatsRequest();
    m = Object.assign(m, proto);
    if (proto.sender) {
      m.sender = Sender.fromProto(proto.sender);
    }
    if (proto.attribute) {
      m.attribute = Attribute.fromProto(proto.attribute);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sender !== 'undefined' && this.sender !== null) {
      toReturn['sender'] = 'toApiJson' in this.sender ? this.sender.toApiJson() : this.sender;
    }
    if (typeof this.attribute !== 'undefined' && this.attribute !== null) {
      toReturn['attribute'] = 'toApiJson' in this.attribute ? this.attribute.toApiJson() : this.attribute;
    }
    return toReturn;
  }
}
class GetAttributeEventStatsResponse {
  static fromProto(proto) {
    let m = new GetAttributeEventStatsResponse();
    m = Object.assign(m, proto);
    if (proto.stats) {
      m.stats = proto.stats.map(StatusStat.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.stats !== 'undefined' && this.stats !== null) {
      toReturn['stats'] = 'toApiJson' in this.stats ? this.stats.toApiJson() : this.stats;
    }
    return toReturn;
  }
}
class GetLatestA2PRegistrationStatusRequest {
  static fromProto(proto) {
    let m = new GetLatestA2PRegistrationStatusRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.ownerId !== 'undefined') {
      toReturn['ownerId'] = this.ownerId;
    }
    if (typeof this.subaccountId !== 'undefined') {
      toReturn['subaccountId'] = this.subaccountId;
    }
    return toReturn;
  }
}
class GetLatestA2PRegistrationStatusResponse {
  static fromProto(proto) {
    let m = new GetLatestA2PRegistrationStatusResponse();
    m = Object.assign(m, proto);
    if (proto.status) {
      m.status = A2PRegistrationStatus.fromProto(proto.status);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.status !== 'undefined' && this.status !== null) {
      toReturn['status'] = 'toApiJson' in this.status ? this.status.toApiJson() : this.status;
    }
    return toReturn;
  }
}
class GetLimitRequest {
  static fromProto(proto) {
    let m = new GetLimitRequest();
    m = Object.assign(m, proto);
    if (proto.limitType) {
      m.limitType = enumStringToValue(LimitType, proto.limitType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.ownerId !== 'undefined') {
      toReturn['ownerId'] = this.ownerId;
    }
    if (typeof this.limitType !== 'undefined') {
      toReturn['limitType'] = this.limitType;
    }
    return toReturn;
  }
}
class GetLimitResponse {
  static fromProto(proto) {
    let m = new GetLimitResponse();
    m = Object.assign(m, proto);
    if (proto.limitType) {
      m.limitType = enumStringToValue(LimitType, proto.limitType);
    }
    if (proto.usage) {
      m.usage = parseInt(proto.usage, 10);
    }
    if (proto.limit) {
      m.limit = parseInt(proto.limit, 10);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.ownerId !== 'undefined') {
      toReturn['ownerId'] = this.ownerId;
    }
    if (typeof this.limitType !== 'undefined') {
      toReturn['limitType'] = this.limitType;
    }
    if (typeof this.usage !== 'undefined') {
      toReturn['usage'] = this.usage;
    }
    if (typeof this.limit !== 'undefined') {
      toReturn['limit'] = this.limit;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    return toReturn;
  }
}
class Media {
  static fromProto(proto) {
    let m = new Media();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.contentType !== 'undefined') {
      toReturn['contentType'] = this.contentType;
    }
    if (typeof this.locationPath !== 'undefined') {
      toReturn['locationPath'] = this.locationPath;
    }
    if (typeof this.fileName !== 'undefined') {
      toReturn['fileName'] = this.fileName;
    }
    return toReturn;
  }
}
class Recipient {
  static fromProto(proto) {
    let m = new Recipient();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.phoneNumber !== 'undefined') {
      toReturn['phoneNumber'] = this.phoneNumber;
    }
    return toReturn;
  }
}
class SendMessageRequest {
  static fromProto(proto) {
    let m = new SendMessageRequest();
    m = Object.assign(m, proto);
    if (proto.media) {
      m.media = proto.media.map(Media.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.conversationId !== 'undefined') {
      toReturn['conversationId'] = this.conversationId;
    }
    if (typeof this.recipientPhoneNumber !== 'undefined') {
      toReturn['recipientPhoneNumber'] = this.recipientPhoneNumber;
    }
    if (typeof this.messageBody !== 'undefined') {
      toReturn['messageBody'] = this.messageBody;
    }
    if (typeof this.media !== 'undefined' && this.media !== null) {
      toReturn['media'] = 'toApiJson' in this.media ? this.media.toApiJson() : this.media;
    }
    return toReturn;
  }
}
class SendMessageResponse {
  static fromProto(proto) {
    let m = new SendMessageResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.messageId !== 'undefined') {
      toReturn['messageId'] = this.messageId;
    }
    if (typeof this.conversationId !== 'undefined') {
      toReturn['conversationId'] = this.conversationId;
    }
    return toReturn;
  }
}
class SendMessageV2Request {
  static fromProto(proto) {
    let m = new SendMessageV2Request();
    m = Object.assign(m, proto);
    if (proto.sender) {
      m.sender = Sender.fromProto(proto.sender);
    }
    if (proto.recipient) {
      m.recipient = Recipient.fromProto(proto.recipient);
    }
    if (proto.attributes) {
      m.attributes = proto.attributes.map(Attribute.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sender !== 'undefined' && this.sender !== null) {
      toReturn['sender'] = 'toApiJson' in this.sender ? this.sender.toApiJson() : this.sender;
    }
    if (typeof this.recipient !== 'undefined' && this.recipient !== null) {
      toReturn['recipient'] = 'toApiJson' in this.recipient ? this.recipient.toApiJson() : this.recipient;
    }
    if (typeof this.messageBody !== 'undefined') {
      toReturn['messageBody'] = this.messageBody;
    }
    if (typeof this.attributes !== 'undefined' && this.attributes !== null) {
      toReturn['attributes'] = 'toApiJson' in this.attributes ? this.attributes.toApiJson() : this.attributes;
    }
    if (typeof this.idempotencyKey !== 'undefined') {
      toReturn['idempotencyKey'] = this.idempotencyKey;
    }
    return toReturn;
  }
}
class SendMessageV2Response {
  static fromProto(proto) {
    let m = new SendMessageV2Response();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.messageId !== 'undefined') {
      toReturn['messageId'] = this.messageId;
    }
    return toReturn;
  }
}
class Sender {
  static fromProto(proto) {
    let m = new Sender();
    m = Object.assign(m, proto);
    if (proto.ownerType) {
      m.ownerType = enumStringToValue(OwnerType, proto.ownerType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.ownerId !== 'undefined') {
      toReturn['ownerId'] = this.ownerId;
    }
    if (typeof this.ownerType !== 'undefined') {
      toReturn['ownerType'] = this.ownerType;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    return toReturn;
  }
}
class StatusStat {
  static fromProto(proto) {
    let m = new StatusStat();
    m = Object.assign(m, proto);
    if (proto.status) {
      m.status = enumStringToValue(StatusType, proto.status);
    }
    if (proto.value) {
      m.value = parseInt(proto.value, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class TriggerA2PRegistrationRequest {
  static fromProto(proto) {
    let m = new TriggerA2PRegistrationRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.ownerId !== 'undefined') {
      toReturn['ownerId'] = this.ownerId;
    }
    return toReturn;
  }
}
class UpsertA2PRegistrationInfoRequest {
  static fromProto(proto) {
    let m = new UpsertA2PRegistrationInfoRequest();
    m = Object.assign(m, proto);
    if (proto.ownerType) {
      m.ownerType = enumStringToValue(OwnerType, proto.ownerType);
    }
    if (proto.business) {
      m.business = Business.fromProto(proto.business);
    }
    if (proto.authorizedRepresentative) {
      m.authorizedRepresentative = AuthorizedRepresentative.fromProto(proto.authorizedRepresentative);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.ownerId !== 'undefined') {
      toReturn['ownerId'] = this.ownerId;
    }
    if (typeof this.ownerType !== 'undefined') {
      toReturn['ownerType'] = this.ownerType;
    }
    if (typeof this.business !== 'undefined' && this.business !== null) {
      toReturn['business'] = 'toApiJson' in this.business ? this.business.toApiJson() : this.business;
    }
    if (typeof this.authorizedRepresentative !== 'undefined' && this.authorizedRepresentative !== null) {
      toReturn['authorizedRepresentative'] = 'toApiJson' in this.authorizedRepresentative ? this.authorizedRepresentative.toApiJson() : this.authorizedRepresentative;
    }
    if (typeof this.submitted !== 'undefined') {
      toReturn['submitted'] = this.submitted;
    }
    return toReturn;
  }
}

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Objects Index.
// *********************************

const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'sms-api.vendasta-local.com',
  'test': '',
  'demo': 'sms-demo.apigateway.co',
  'prod': 'sms-prod.apigateway.co',
  'production': 'sms-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(t) {
    return new (t || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let A2PRegistrationApiService = /*#__PURE__*/(() => {
  class A2PRegistrationApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createA2pRegistrationInfo(r) {
      const request = r.toApiJson ? r : new CreateA2PRegistrationInfoRequest(r);
      return this.http.post(this._host + "/sms.v2.A2PRegistration/CreateA2PRegistrationInfo", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getA2pRegistrationInfo(r) {
      const request = r.toApiJson ? r : new GetA2PRegistrationInfoRequest(r);
      return this.http.post(this._host + "/sms.v2.A2PRegistration/GetA2PRegistrationInfo", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetA2PRegistrationInfoResponse.fromProto(resp)));
    }
    deleteA2pRegistrationInfo(r) {
      const request = r.toApiJson ? r : new DeleteA2PRegistrationInfoRequest(r);
      return this.http.post(this._host + "/sms.v2.A2PRegistration/DeleteA2PRegistrationInfo", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    upsertA2pRegistrationInfo(r) {
      const request = r.toApiJson ? r : new UpsertA2PRegistrationInfoRequest(r);
      return this.http.post(this._host + "/sms.v2.A2PRegistration/UpsertA2PRegistrationInfo", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getLatestA2pRegistrationStatus(r) {
      const request = r.toApiJson ? r : new GetLatestA2PRegistrationStatusRequest(r);
      return this.http.post(this._host + "/sms.v2.A2PRegistration/GetLatestA2PRegistrationStatus", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetLatestA2PRegistrationStatusResponse.fromProto(resp)));
    }
    triggerA2pRegistration(r) {
      const request = r.toApiJson ? r : new TriggerA2PRegistrationRequest(r);
      return this.http.post(this._host + "/sms.v2.A2PRegistration/TriggerA2PRegistration", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  A2PRegistrationApiService.ɵfac = function A2PRegistrationApiService_Factory(t) {
    return new (t || A2PRegistrationApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  A2PRegistrationApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: A2PRegistrationApiService,
    factory: A2PRegistrationApiService.ɵfac,
    providedIn: 'root'
  });
  return A2PRegistrationApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let ConversationApiService = /*#__PURE__*/(() => {
  class ConversationApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    sendMessage(r) {
      const request = r.toApiJson ? r : new SendMessageRequest(r);
      return this.http.post(this._host + "/sms.v2.ConversationService/SendMessage", request.toApiJson(), this.apiOptions()).pipe(map(resp => SendMessageResponse.fromProto(resp)));
    }
    claimPhoneNumber(r) {
      const request = r.toApiJson ? r : new ClaimPhoneNumberRequest(r);
      return this.http.post(this._host + "/sms.v2.ConversationService/ClaimPhoneNumber", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  ConversationApiService.ɵfac = function ConversationApiService_Factory(t) {
    return new (t || ConversationApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  ConversationApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ConversationApiService,
    factory: ConversationApiService.ɵfac,
    providedIn: 'root'
  });
  return ConversationApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let EventApiService = /*#__PURE__*/(() => {
  class EventApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getAttributeEventStats(r) {
      const request = r.toApiJson ? r : new GetAttributeEventStatsRequest(r);
      return this.http.post(this._host + "/sms.v2.EventService/GetAttributeEventStats", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetAttributeEventStatsResponse.fromProto(resp)));
    }
  }
  EventApiService.ɵfac = function EventApiService_Factory(t) {
    return new (t || EventApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  EventApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: EventApiService,
    factory: EventApiService.ɵfac,
    providedIn: 'root'
  });
  return EventApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let RegulationApiService = /*#__PURE__*/(() => {
  class RegulationApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createRegulationInfo(r) {
      const request = r.toApiJson ? r : new CreateRegulationInfoRequest(r);
      return this.http.post(this._host + "/sms.v2.RegulationService/CreateRegulationInfo", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateRegulationInfoResponse.fromProto(resp)));
    }
  }
  RegulationApiService.ɵfac = function RegulationApiService_Factory(t) {
    return new (t || RegulationApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  RegulationApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: RegulationApiService,
    factory: RegulationApiService.ɵfac,
    providedIn: 'root'
  });
  return RegulationApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let SmsApiService = /*#__PURE__*/(() => {
  class SmsApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createSmsClickedEvent(r) {
      const request = r.toApiJson ? r : new CreateSmsClickedEventRequest(r);
      return this.http.post(this._host + "/sms.v2.SmsService/CreateSmsClickedEvent", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getAccountInfo(r) {
      const request = r.toApiJson ? r : new GetAccountInfoRequest(r);
      return this.http.post(this._host + "/sms.v2.SmsService/GetAccountInfo", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetAccountInfoResponse.fromProto(resp)));
    }
    sendMessageV2(r) {
      const request = r.toApiJson ? r : new SendMessageV2Request(r);
      return this.http.post(this._host + "/sms.v2.SmsService/SendMessageV2", request.toApiJson(), this.apiOptions()).pipe(map(resp => SendMessageV2Response.fromProto(resp)));
    }
    getLimit(r) {
      const request = r.toApiJson ? r : new GetLimitRequest(r);
      return this.http.post(this._host + "/sms.v2.SmsService/GetLimit", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetLimitResponse.fromProto(resp)));
    }
  }
  SmsApiService.ɵfac = function SmsApiService_Factory(t) {
    return new (t || SmsApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  SmsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SmsApiService,
    factory: SmsApiService.ɵfac,
    providedIn: 'root'
  });
  return SmsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Index.
// *********************************
let SmsService = /*#__PURE__*/(() => {
  class SmsService {
    constructor(smsApiService) {
      this.smsApiService = smsApiService;
    }
    getAccountInfo(sender) {
      return this.smsApiService.getAccountInfo({
        sender: sender
      });
    }
  }
  SmsService.ɵfac = function SmsService_Factory(t) {
    return new (t || SmsService)(i0.ɵɵinject(SmsApiService));
  };
  SmsService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SmsService,
    factory: SmsService.ɵfac,
    providedIn: 'root'
  });
  return SmsService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EventService = /*#__PURE__*/(() => {
  class EventService {
    constructor(eventService) {
      this.eventService = eventService;
    }
    getAttributeEventStats(sender, attribute) {
      return this.eventService.getAttributeEventStats({
        sender: sender,
        attribute: attribute
      });
    }
  }
  EventService.ɵfac = function EventService_Factory(t) {
    return new (t || EventService)(i0.ɵɵinject(EventApiService));
  };
  EventService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: EventService,
    factory: EventService.ɵfac,
    providedIn: 'root'
  });
  return EventService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { A2PRegistrationApiService, A2PRegistrationInfo, A2PRegistrationStatus, Access, Attribute, AuthorizedRepresentative, Brand, BrandStatus, Business, ClaimPhoneNumberRequest, ConversationApiService, CreateA2PRegistrationInfoRequest, CreateRegulationInfoRequest, CreateRegulationInfoResponse, CreateSmsClickedEventRequest, DataField, DeleteA2PRegistrationInfoRequest, EventApiService, EventService, GetA2PRegistrationInfoRequest, GetA2PRegistrationInfoResponse, GetAccountInfoRequest, GetAccountInfoResponse, GetAttributeEventStatsRequest, GetAttributeEventStatsResponse, GetLatestA2PRegistrationStatusRequest, GetLatestA2PRegistrationStatusResponse, GetLimitRequest, GetLimitResponse, LimitType, Media, MessagingCampaign, MessagingCampaignStatus, OwnerType, Participant, ParticipantType, Recipient, RegistrationIdentifier, RegulationApiService, SecondaryBusinessProfile, SendMessageRequest, SendMessageResponse, SendMessageV2Request, SendMessageV2Response, Sender, SmsApiService, SmsService, StatusStat, StatusType, SupportingDocumentInfo, TriggerA2PRegistrationRequest, TrustBundle, UpsertA2PRegistrationInfoRequest, ValidationStatus };
